import NativeScrollbar from './native-scrollbar';

const selectors = {
  body: 'body',
  dataRelatedSectionElem: '[data-related-section]',
  dataTab: 'data-tab',
  dataTabIndex: 'data-tab-index',
  blockId: 'data-block-id',
  tabsLi: 'ul.tabs > li',
  tabLink: '.tab-link',
  tabLinkRecent: '.tab-link__recent',
  tabContent: '.tab-content',
  scrollbarHolder: '[data-scrollbar]',
  scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
  scrollbarArrowNext: '[data-scrollbar-arrow-next]',
};

const classes = {
  classCurrent: 'current',
  classHide: 'hide',
  classAlt: 'alt',
};

const sections = {};

class GlobalTabs {
  constructor(section) {
    this.container = section.container;
    this.body = document.querySelector(selectors.body);
    this.accessibility = window.accessibility;

    if (this.container) {
      this.scrollbarHolder = this.container.querySelectorAll(selectors.scrollbarHolder);

      this.init();

      // Init native scrollbar
      this.initNativeScrollbar();
    }
  }

  init() {
    const ctx = this.container;
    const tabsNavList = ctx.querySelectorAll(selectors.tabsLi);
    const firstTabLink = ctx.querySelector(`${selectors.tabLink}-0`);
    const firstTabContent = ctx.querySelector(`${selectors.tabContent}-0`);

    if (firstTabContent) {
      firstTabContent.classList.add(classes.classCurrent);
    }

    if (firstTabLink) {
      firstTabLink.classList.add(classes.classCurrent);
    }

    this.checkVisibleTabLinks();
    this.container.addEventListener('tabs:checkRecentTab', () => this.checkRecentTab());
    this.container.addEventListener('tabs:hideRelatedTab', () => this.hideRelatedTab());

    if (tabsNavList.length) {
      tabsNavList.forEach((element) => {
        const tabId = parseInt(element.getAttribute(selectors.dataTab));
        const tab = ctx.querySelector(`${selectors.tabContent}-${tabId}`);

        element.addEventListener('click', () => {
          this.tabChange(element, tab);
        });

        element.addEventListener('keyup', (event) => {
          if ((event.which === window.theme.keyboardKeys.SPACE || event.which === window.theme.keyboardKeys.ENTER) && this.body.classList.contains('is-focused')) {
            this.tabChange(element, tab);

            if (tab.querySelector('a, input')) {
              this.accessibility.lastFocused = element;

              this.accessibility.a11y.trapFocus(tab, {
                elementToFocus: tab.querySelector('a:first-child, input:first-child'),
              });
            }
          }
        });
      });
    }
  }

  tabChange(element, tab) {
    this.container.querySelector(`${selectors.tabsLi}.${classes.classCurrent}`).classList.remove(classes.classCurrent);
    this.container.querySelector(`${selectors.tabContent}.${classes.classCurrent}`).classList.remove(classes.classCurrent);

    element.classList.add(classes.classCurrent);
    tab.classList.add(classes.classCurrent);

    if (element.classList.contains(classes.classHide)) {
      tab.classList.add(classes.classHide);
    }

    this.checkVisibleTabLinks();

    this.accessibility.a11y.removeTrapFocus();
  }

  initNativeScrollbar() {
    if (this.scrollbarHolder.length) {
      this.scrollbarHolder.forEach((scrollbar) => {
        new NativeScrollbar(scrollbar);
      });
    }
  }

  checkVisibleTabLinks() {
    const tabsNavList = this.container.querySelectorAll(selectors.tabsLi);
    const tabsNavListHided = this.container.querySelectorAll(`${selectors.tabLink}.${classes.classHide}`);
    const difference = tabsNavList.length - tabsNavListHided.length;

    if (difference < 2) {
      this.container.classList.add(classes.classAlt);
    } else {
      this.container.classList.remove(classes.classAlt);
    }
  }

  checkRecentTab() {
    const tabLink = this.container.querySelector(selectors.tabLinkRecent);

    if (tabLink) {
      tabLink.classList.remove(classes.classHide);
      const tabLinkIdx = parseInt(tabLink.getAttribute(selectors.dataTab));
      const tabContent = this.container.querySelector(`${selectors.tabContent}[${selectors.dataTabIndex}="${tabLinkIdx}"]`);

      if (tabContent) {
        tabContent.classList.remove(classes.classHide);
      }

      this.checkVisibleTabLinks();
    }
  }

  hideRelatedTab() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);
    if (!relatedSection) {
      return;
    }

    const parentTabContent = relatedSection.closest(`${selectors.tabContent}.${classes.classCurrent}`);
    if (!parentTabContent) {
      return;
    }
    const parentTabContentIdx = parseInt(parentTabContent.getAttribute(selectors.dataTabIndex));
    const tabsNavList = this.container.querySelectorAll(selectors.tabsLi);

    if (tabsNavList.length > parentTabContentIdx) {
      const nextTabsNavLink = tabsNavList[parentTabContentIdx].nextSibling;

      if (nextTabsNavLink) {
        tabsNavList[parentTabContentIdx].classList.add(classes.classHide);
        nextTabsNavLink.dispatchEvent(new Event('click'));
      }
    }
  }

  onBlockSelect(evt) {
    const element = this.container.querySelector(`${selectors.tabLink}[${selectors.blockId}="${evt.detail.blockId}"]`);
    if (element) {
      element.dispatchEvent(new Event('click'));

      element.parentNode.scrollTo({
        top: 0,
        left: element.offsetLeft - element.clientWidth,
        behavior: 'smooth',
      });
    }
  }
}

const tabs = {
  onLoad() {
    sections[this.id] = new GlobalTabs(this);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

export default tabs;
